import prefecture from "./constants/prefecture";
import licence from "./constants/licence";
import document_type from "./constants/document_type";
import broker_status from "@/constants/broker_status";
import issuance_request from '@/constants/issuance_request'
import payment_method from "@/constants/payment_method";
import guest_type from "@/constants/guest_type";
import operation_log from "@/constants/operation_log";
import management_company from "@/constants/management_company";

export default {
  PAGINATION: {
    PER_PAGE: 50,
  },
  NOTIFICATER: {
    PER_PAGE: 10,
    FETCH_INTERVAL_TIME: 300000,
  },
  PREFECTURE: {
    LIST: prefecture.list
  },
  LICENCE: {
    TYPE_LIST: licence.typeList,
    COUNT_LIST: licence.countList
  },
  DOCUMENT_TYPE: {
    LIST: document_type.list,
    LIST_FOR_BROKER: document_type.list_for_broker,
    HIDDEN: document_type.hidden,
    UNNECESSARY: document_type.unnecessary,
    ATTACHED_NONE: document_type.attached_none,
  },
  BROKER_SUPERVISOR_LIST: [
    { value: 1, text: "管理者のみ" },
    { value: 0, text: "管理者以外" },
  ],
  BROKER_STATUS: {
    DISABLED: broker_status.disabled,
    ENABLED: broker_status.enabled
  },
  REQUIRED_DOCUMENT_OPTIONS: {
    REQUIRED: 0,
    NOT_REQUIRED: 1,
    HIDDEN: 2,
  },
  BROKER_STATUS_LIST: broker_status.list,
  OPERATION_TYPE_LIST: operation_log.typeList,
  ISSUANCE_REQUEST_STATUS: issuance_request.status,
  ISSUANCE_REQUEST_STATUS_LIST: Object.values(issuance_request.status),
  ALLOWED_UPLOAD_TRANSFER_STATEMENT_CODE: issuance_request.allowed_upload_transfer_statement_code,
  ALLOWED_DELETE_TRANSFER_STATEMENT_CODE: issuance_request.allowed_delete_transfer_statement_code,
  ISSUANCE_REQUEST_MAX_BUILDING_LIST_ITEMS: issuance_request.max_building_list_items,
  PAYMENT_METHOD_CODE: payment_method.code,
  IS_POSTPAY_ALLOWED_CODE: payment_method.postpayCode,
  GUEST_TYPE: guest_type.code,
  BROKER_MANUAL_URL: "https://manual.jyurep.classcity.jp/重調＠CITY_操作マニュアル_仲介会社.pdf",
  ISSUANCE_REQUEST_OPERATION: issuance_request.operation,
  INTERVAL_DELAY: {
    MINUTE: 5,
  },
  MANAGEMENT_TYPE: '管理会社',
  REISSUE_POSSIBLE_TYPE: {
    LIST: Object.values(management_company.reissuePossibleTypeList),
    ONLY_IN_EXPIRATION: management_company.reissuePossibleTypeList.ONLY_IN_EXPIRATION,
    ALWAYS: management_company.reissuePossibleTypeList.ALWAYS,
  },
  RECEIPT_STATUS: issuance_request.receipt_status,
};
